// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3eTfT","btn":"styles_btn__HPAVc"};